import { render, staticRenderFns } from "./TypeColumnTemplate.vue?vue&type=template&id=74fac023"
import script from "./TypeColumnTemplate.vue?vue&type=script&lang=js"
export * from "./TypeColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports